import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import InlineSVG from 'svg-inline-react'
import { CSSTransition } from 'react-transition-group'

import CheckboxSelected from 'assets/icons/input-checkbox-selected.svg'
import CheckboxUnselected from 'assets/icons/input-checkbox-unselected.svg'

const customStyles = props => props.customStyles && props.customStyles

const CheckboxContainer = styled.div`
  cursor: pointer;
  
  ${customStyles}
`

const Checkbox = ({
  checked,
  onChange,
  customStyles
}) => (
  <CheckboxContainer
    onClick={onChange}
    customStyles={customStyles}
  >
    {
      checked
        ? <CSSTransition
          in={checked}
          timeout={500}
          classNames='item-transition'
        >
          <InlineSVG src={CheckboxSelected} />
        </CSSTransition>

        : <CSSTransition
          in={checked}
          timeout={500}
          classNames='item-transition'
        >
          <InlineSVG src={CheckboxUnselected} />
        </CSSTransition>
    }
  </CheckboxContainer>
)
Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  customStyles: PropTypes.any
}

export default Checkbox
